import PortableBlocks from './PortableBlocks'

export default PortableBlocks
